/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetFwWars200Ok
 */
export interface GetFwWars200Ok {
    /**
     * The faction ID of the enemy faction.
     * @type {number}
     * @memberof GetFwWars200Ok
     */
    againstId: number;
    /**
     * faction_id integer
     * @type {number}
     * @memberof GetFwWars200Ok
     */
    factionId: number;
}

/**
 * Check if a given object implements the GetFwWars200Ok interface.
 */
export function instanceOfGetFwWars200Ok(value: object): value is GetFwWars200Ok {
    if (!('againstId' in value) || value['againstId'] === undefined) return false;
    if (!('factionId' in value) || value['factionId'] === undefined) return false;
    return true;
}

export function GetFwWars200OkFromJSON(json: any): GetFwWars200Ok {
    return GetFwWars200OkFromJSONTyped(json, false);
}

export function GetFwWars200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFwWars200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'againstId': json['against_id'],
        'factionId': json['faction_id'],
    };
}

export function GetFwWars200OkToJSON(json: any): GetFwWars200Ok {
    return GetFwWars200OkToJSONTyped(json, false);
}

export function GetFwWars200OkToJSONTyped(value?: GetFwWars200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'against_id': value['againstId'],
        'faction_id': value['factionId'],
    };
}

